import { useNavigate } from 'react-router-dom'
import { trackInternalEvent } from '@rio/tracking'

import { useI18n } from 'builder/hooks/useI18n'
import useWebsiteHost from 'builder/components/CIO-Dasboard-2.0/hooks/useWebsiteHost'
import { useResumeDistribution } from 'builder/views/ResumeDistributionView/hooks/useResumeDistribution'

import {
  ActionButton,
  Container,
  Header,
  HeaderContainer,
  ImageContainer,
  SubHeader,
} from './styles'
import CoverImg from './assets/banner-cover.png'

const TRANSLATION = 'builder.dashboard.job_search_help.resume_distribution.banner'

export const Banner = () => {
  const { i18n } = useI18n()
  const navigate = useNavigate()
  const { getHost } = useWebsiteHost()
  const { showRDUpsellPromoModal } = useResumeDistribution()

  const onClickRd = () => {
    if (showRDUpsellPromoModal()) return
    trackInternalEvent('job_search_help_banner_click', {
      website_host: getHost,
      label: 'resume_distribution',
    })
    navigate('/resume-distribution')
  }

  return (
    <Container>
      <HeaderContainer>
        <Header>{i18n.t(`${TRANSLATION}.header`)}</Header>
        <SubHeader>{i18n.t(`${TRANSLATION}.sub_header`)}</SubHeader>

        <ActionButton onClick={onClickRd}>{i18n.t(`${TRANSLATION}.action`)}</ActionButton>
      </HeaderContainer>
      <ImageContainer src={CoverImg} />
    </Container>
  )
}
